"use strict";
/**
 * A consent form carries a document title that is independent of the file it was uploaded from.
 * Renaming the title must never rewrite the stored file name, so the two are normalized apart:
 * this module owns the title rules only.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeDocumentTitle = exports.DOCUMENT_TITLE_MAX_LENGTH = void 0;
/** Longest title the Library accepts. Mirrored by the Library's own validation. */
exports.DOCUMENT_TITLE_MAX_LENGTH = 512;
/**
 * Collapses every run of whitespace to a single space and trims the ends. Studio sends the
 * collapsed form so that the title it renders next matches the one the Library stored, rather
 * than drifting until the next read.
 */
const normalizeDocumentTitle = (title) => title.trim().replace(/\s+/g, ' ');
exports.normalizeDocumentTitle = normalizeDocumentTitle;
//# sourceMappingURL=document_title.js.map